import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff'
import CloseIcon from '@mui/icons-material/Close'
import CleaningServicesIcon from '@mui/icons-material/CleaningServices'
import { CocktailIcon } from '../../../components/ForEscapeIcons'

// Brushes for planning
export const BRUSH_CLEAR = 'clear'
export const BRUSH_NOT_AVAILABLE = 'notAvailable'
export const BRUSH_LOCK = 'lock'
export const BRUSH_UNLOCK = 'unlock'
export const BRUSH_COCKTAIL = 'cocktail'
export const BRUSH_FILMING = 'filming'
export const BRUSH_NOSHOW = 'noshow'
export const BRUSH_HIGHLIGHT = 'highlight'
export const BRUSH_NEUTRAL = 'neutral'
export const BRUSH_MANAGER_35 = 'manager_35'
export const BRUSH_MANAGER_35_DURATION = 35 * 60 * 1000
export const BRUSH_MANAGER_35_SYMBOL = <HistoryToggleOffIcon />
export const BRUSH_FILMING_SYMBOL = '🎥'
export const BRUSH_NOSHOW_SYMBOL = <VisibilityOffIcon />
export const ALL_BRUSHES = [
  {
    value: BRUSH_CLEAR,
    symbol: <PanoramaFishEyeIcon />,
  },
  {
    value: BRUSH_NOT_AVAILABLE,
    symbol: <CloseIcon htmlColor="black" />,
  },
  {
    value: BRUSH_LOCK,
    symbol: '🔒',
  },
  {
    value: BRUSH_UNLOCK,
    symbol: '🔑',
  },
  {
    value: BRUSH_COCKTAIL,
    symbol: <CocktailIcon />,
  },
  {
    value: BRUSH_FILMING,
    symbol: BRUSH_FILMING_SYMBOL,
  },
  {
    value: BRUSH_NOSHOW,
    symbol: BRUSH_NOSHOW_SYMBOL,
  },
  {
    value: BRUSH_HIGHLIGHT,
    symbol: '✨',
  },
  {
    value: BRUSH_NEUTRAL,
    symbol: <CleaningServicesIcon />,
  },
  {
    value: BRUSH_MANAGER_35,
    symbol: BRUSH_MANAGER_35_SYMBOL,
  },
]
